import { lazy } from "react"
import type { CustomRoute } from "@/shared/types"

const DashboardComponent = lazy(async () => await import("../dashboard-page"))

export const dashboardPageRoutes: CustomRoute = {
  path: "/dashboard",
  handle: { label: "Мониторинг", icon: "ChartRing", i18Key: "monitoring", allowedRoles: ["republic_inspector", "super_admin"] },
  Component: DashboardComponent
}
